"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import type { NavSearchCategory } from "./nav-search-data";

export function useNavSearch() {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const [category, setCategory] = useState<NavSearchCategory>("all");
    const inputRef = useRef<HTMLInputElement>(null);
    const triggerRef = useRef<HTMLButtonElement>(null);
    const restoreFocusRef = useRef(false);
    const wasOpenRef = useRef(false);

    useEffect(() => {
        if (open && !wasOpenRef.current) {
            inputRef.current?.focus();
        }
        if (!open && wasOpenRef.current && restoreFocusRef.current) {
            triggerRef.current?.focus();
            restoreFocusRef.current = false;
        }
        wasOpenRef.current = open;
    }, [open]);

    const openSearch = useCallback(() => setOpen(true), []);

    const closeSearch = useCallback((options?: { restoreFocus?: boolean }) => {
        restoreFocusRef.current = options?.restoreFocus ?? false;
        setOpen(false);
        setQuery("");
        setCategory("all");
    }, []);

    const clearOrClose = useCallback(() => {
        if (query.trim()) {
            setQuery("");
            inputRef.current?.focus();
            return;
        }
        closeSearch({ restoreFocus: true });
    }, [closeSearch, query]);

    return {
        open,
        query,
        setQuery,
        category,
        setCategory,
        inputRef,
        triggerRef,
        openSearch,
        closeSearch,
        clearOrClose,
    };
}
